
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';

const TOOL_STYLE = mergeStyles({
    backgroundColor: 'rgba(128, 128, 128, 0.7)',
    borderRadius: '0px'
});

const getIcon = (name) => {
    return {
        iconName: name,
        style: {
            color: '#ffffff'
        }
    };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    TOOL_STYLE,
    getIcon
}
